<template>
    <div class="d-flex" @click.stop>
        <div @click="showUserQuizModal" class="pointer subnav-link"
             :title="noTooltip ? '' : trans('overview')['students.stats.quiz_answers']">
            <img v-if="userQuiz.quiz.quiz_type === 'essay'" src="/images/svg-icons/marlms-essay-orange.svg" loading="lazy" alt="" class="svg-with-hover-2">
            <img v-else src="/images/svg-icons/marlms-quiz-orange.svg" loading="lazy" alt="" class="svg-with-hover-2">
        </div>
        <div v-if="shown">
            <div class="modal fade" ref="userQuizModal" tabindex="-1" role="dialog" aria-hidden="true"
                 style="visibility: hidden">
                <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document" style="visibility: visible">
                    <div class="modal-content min-keep-size resize">
                        <div class="modal-header flex mb-2">
                            <h5 class="modal-title mb-2" id="userQuizModalLabel">
                                {{ trans('overview')['students.stats.quiz_answers'] }}
                                <div style="font-size: small">
                                    {{ studentCourse.course.name }}
                                    {{ studentCourse.training ? '(' + studentCourse.training.title + ')' : ''}}
                                </div>
                            </h5>
                            <button type="button" class="close no-drag" @click.prevent="hideUserQuizModal">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <course-quiz-part :courseId="studentCourse.course.id"
                                              :studentCourseId="studentCourse.id"
                                              :preview="0" :user="studentCourse.student"
                                              :quiz="userQuiz.quiz"
                                              :coach-view="true"
                            ></course-quiz-part>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" @click.prevent="hideUserQuizModal">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "StudentQuizViewer",
    components: {},
    props: {
        studentCourse: Object,
        userQuiz: Object,
        open: {
            type: Boolean,
            default: false,
        },
        noTooltip: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["close"],
    data() {
        return {
            shown: false,
        }
    },
    watch: {
        open: function (val) {
            if (val) {
                this.showUserQuizModal();
            }
        }
    },
    methods: {
        showUserQuizModal() {
            this.shown = true;
            this.$nextTick(() => {
                $(this.$refs.userQuizModal).modal('show');
            })

        },
        hideUserQuizModal() {
            $(this.$refs.userQuizModal).modal('hide');
            this.shown = false;
            this.$emit("close");
        },
    }
}
</script>

<style scoped>

</style>
